import { HttpClient, HttpParams } from '@angular/common/http';;
import { Injectable } from "@angular/core";
import { API_URL } from "../../configurations/server-config";
import { DatePipe } from "@angular/common";

@Injectable({
  providedIn: "root",
})
export class ColissessionService {
  constructor(private http: HttpClient, private datepipe: DatePipe) {}

  getAllSession(page = 0, size = 100): any {
    return this.http.get(`${API_URL}/session?page=${page}&size=${size}`);
  }

  getAllSessionColisOrGuichet(
    sessionid: any,
    type: any,
    page = 0,
    size = 100
  ): any {
    return this.http.get(
      `${API_URL}/sessioncollisguichet?page=${page}&size=${size}&sid=${sessionid}&ty=${type}`
    );
  }

  getAllSessionByType(
    type: any,
    page = 0,
    size = 100,
    sortby = null,
    orderby = null
  ): any {
    return this.http.get(
      `${API_URL}/sessionbytype?page=${page}&size=${size}&ty=${type}&sortby=${sortby}&direction=${orderby}`
    );
  }

  getAllSessionOther(page = 0, size = 100, sortby = null, orderby = null): any {
    return this.http.get(
      `${API_URL}/session/other?page=${page}&size=${size}&sort=${sortby}&direction=${orderby}`
    );
  }

  closeAllSessionsForDate(date: string | null = null): any {
    const params = date ? `?date=${date}` : '';
    return this.http.post(`${API_URL}/session/close-all-for-date${params}`, null);
  }

  getSessionOptions(criteria: any): any {
    return this.http.post(`${API_URL}/session/criteria/options`, criteria);
  }

  closeSessionManually(sessionId: string): any {
    return this.http.post(`${API_URL}/session/close-manually?sessionId=${sessionId}`, null);
  }

  getsessiondetail(id: string): any {
    return this.http.get(`${API_URL}/sessiondetail?p=${id}`);
  }

  getAllUserSession(page = 0, size = 100, id: any): any {
    return this.http.get(`${API_URL}/session/${id}?page=${page}&size=${size}`);
  }

  updateSessionType(type: any, sessionid: any): any {
    return this.http.post(
      `${API_URL}/sessiontype?type=${type}&sid=${sessionid}`,
      null
    );
  }

  getAllsessionDate(): any {
    return this.http.get(`${API_URL}/getsessionopendate`);
  }

  getAllsessionUser(): any {
    return this.http.get(`${API_URL}/getsessionuser`);
  }

  filtersession(
    user: any = null,
    date: any = null,
    page = 0,
    size = 100,
    sortby = null,
    orderby = null
  ): any {
    if (date != null) {
      date = this.datepipe.transform(date, "yyyy-MM-dd");
    }
    return this.http.get(
      `${API_URL}/filtersession?user=${user}&start=${date}&page=${page}&size=${size}&sortby=${sortby}&direction=${orderby}`
    );
  }

  filtersessionguichet(
    user: any = null,
    date: any = null,
    page = 0,
    size = 100,
    sortby = null,
    orderby = null
  ): any {
    if (date != null) {
      date = this.datepipe.transform(date, "yyyy-MM-dd");
    }
    return this.http.get(
      `${API_URL}/filtersessionguichet?user=${user}&start=${date}&page=${page}&size=${size}&sortby=${sortby}&direction=${orderby}`
    );
  }

  updateSessionStatus(sessionid: any): any {
    return this.http.post(
      `${API_URL}/updatesessionstatus?id=${sessionid}`,
      null
    );
  }

  // check colis duplicate in session
  getAllUserColisDuplicateSession(id: any): any {
    return this.http.get(`${API_URL}/colisduplicate?id=${id}`);
  }

  // check colis duplicate in session
  getAllUserPassengerTicketDuplicateSession(id: any): any {
    return this.http.get(`${API_URL}/passagervoyageduplicate?id=${id}`);
  }

  getReportOfTripInSession(id: any): any {
    return this.http.get(`${API_URL}/raportvoyagelistinsession?id=${id}`);
  }

  getCriteriaSearch(criteria: any, page = 0, size = 10, sort = 'creationDate', direction = 'desc'): any {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('sort', sort || 'creationDate')
      .set('direction', direction || 'desc');
      
    Object.keys(criteria).forEach(key => {
      if (criteria[key] !== null && criteria[key] !== undefined && criteria[key] !== '') {
        params = params.set(key, criteria[key]);
      }
    });

    return this.http.get(`${API_URL}/session/criteria`, { params });
  }

}